import { render, staticRenderFns } from "./RevShareCampaigns.vue?vue&type=template&id=0b070e32"
import script from "./RevShareCampaigns.vue?vue&type=script&lang=js"
export * from "./RevShareCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports